var _path, _path2, _g, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaps = function SvgMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M15.028 19.537H6a2 2 0 0 0-2 2v43.515a2 2 0 0 0 2 2h42.545a2 2 0 0 0 2-2V54.864H17.028a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M15.028 13.718h-3.21a2 2 0 0 0-2 2v43.515a2 2 0 0 0 2 2h42.546a2 2 0 0 0 2-2v-4.369H17.028a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#maps_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.952,
    height: 35.647,
    x: 38.917,
    y: -20.47,
    fill: "#B4CFFF",
    rx: 2,
    transform: "rotate(46.257 38.917 -20.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.011,
    height: 10.764,
    x: 32.242,
    y: 27.232,
    fill: "#FF9D43",
    rx: 2,
    transform: "rotate(46.257 32.242 27.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.852,
    height: 26.663,
    x: 22.381,
    y: 36.669,
    fill: "#FFD2A8",
    rx: 2,
    transform: "rotate(46.257 22.38 36.669)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.426,
    height: 24.826,
    x: 60.654,
    y: 17.582,
    fill: "#6C9BF1",
    rx: 2,
    transform: "rotate(46.257 60.654 17.582)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.36,
    height: 10.804,
    x: 42.822,
    y: 38.432,
    fill: "#2F68D1",
    rx: 2,
    transform: "rotate(46.257 42.822 38.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.393,
    height: 27.01,
    x: 9.357,
    y: 3.465,
    fill: "#2F68D1",
    rx: 2,
    transform: "rotate(46.257 9.357 3.465)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M58.263 35.775C61.541 29.792 68 17.39 68 12.556 68 6.08 62.807.827 56.402.827S44.803 6.08 44.803 12.557c0 4.833 6.46 17.235 9.737 23.218a2.11 2.11 0 0 0 3.723 0m-1.861-17.55a5.8 5.8 0 1 0 0-11.599 5.8 5.8 0 0 0 0 11.599",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.402,
    cy: 12.425,
    r: 5.799,
    fill: "#FDFDFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "maps_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.523,
    height: 48.523,
    x: 15.028,
    y: 6.341,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgMaps;